import { CommonPaymentElementPropTypes } from '../../../propTypes';

export const OxxoFormPropTypes = {
  ...CommonPaymentElementPropTypes,
};
